module.exports = __webpack_public_path__ + "images/TrelloGoldIcon.3cbf48993d46484c5d82.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/TrelloGoldIcon.png
// module id = lRvE
// module chunks = 12